import { NumberLiteralType } from "typescript";

export class DonationHistory {
  chargeId: string;
    donationDate: Date;
    donationAmount: number;
    givingType:string;
  }
  